<template>
<div>
    <template v-if="action=='view'">
        <div class="row">
            <div class="col-12 col-xl-8">
                <div class="card card-body bg-white border-light shadow-sm mb-4">
                    <h2 class="h5 mb-4">General information </h2>
                    <div class="row">
                        <!-- <div class="col-md-6 mb-3">
                                <MssInput v-model="form.linkname" placeholder="Enter Page Link" required></MssInput>
                            </div> -->
                        <div class="col-md-6 mb-3">
                            <MssInput v-model="form.username" placeholder="Enter Username" required="required"></MssInput>
                        </div>
                        <div class="col-md-6 mb-3">
                            <MssInput v-model="form.email" placeholder="Enter Email" required="required"></MssInput>
                        </div>
                        <div class="col-md-6 mb-3">
                            <MssInput v-model="form.mobile" placeholder="Enter Mobile Number" required="required"></MssInput>
                        </div>
                        <div class="col-md-6 mb-3">
                            <MssInput v-model="form.pass" placeholder="Enter Password" required="required"></MssInput>
                        </div>

                        <div class="col-md-6 mb-3">
                            <!-- <MssInput type="file" v-model="form.front_image" placeholder="Main Image " required="required"></MssInput> -->
                            <label>Profile Picture <i>Upload Image (Size max 1MB)</i></label>
                            <input class="form-control" type="file" id="file" ref="avatar" accept="image/*" />
                            <div >
                                <img v-if="form.avatar!=''" :src="$root.URL_ROOT+'uploads/Slider/'+form.avatar" width="200 py-3">
                            </div>
                        </div>

                        <div class="col-md-12 mb-3">
                            <MssInput v-model="form.add1" type="textarea" placeholder="Enter Address" required="required"></MssInput>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-12 col-xl-4 sidebar-stricky">
                <div class="card card-body bg-white border-light shadow-sm mb-4">
                    <h2 class="h5 mb-4">Visibility</h2>
                    <div class="row">
                        <div class="col-md-12 mb-3">
                            <MssInput type="switch" v-model="form.status" placeholder="Visible this page to all"></MssInput>
                        </div>
                        <div class="col-md-12 mb-3">
                            <div>
                                <button @click="submit" class="btn btn-info btn-block" v-if="action=='add'">Publish</button>
                                <button @click="submit" class="btn btn-success btn-block" v-else>Update</button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </template>
</div>
</template>

<script>
import axios from 'axios'
import $ from 'jquery'

export default {
    components: {},
    props: [
        "page", "action", "id"
    ],
    data() {
        return {
            isEditor: true,
            q: '',
            loading: false,
            allData: [],
            form: {
                id: null,
                status: true,
                heading: '',
                heading2: '',
                link: '',
                slider_image: '',
                type: 'updateUser'
            },
            editSEO: false,
            defaultSEO: true,
            pageList: [],
            fullToolbar: [
                [{
                    'font': []
                }],
                [{
                    'header': [false, 1, 2, 3, 4, 5, 6, ]
                }],
                [{
                    'size': ['small', false, 'large', 'huge']
                }],
                ['bold', 'italic', 'underline', 'strike'],
                [{
                    'align': [false, 'justify', 'center', 'right']
                }],
                //[{ 'header': 1 }, { 'header': 2 }],
                //['blockquote', 'code-block'],
                [{
                    'list': 'ordered'
                }, {
                    'list': 'bullet'
                }, {
                    'list': 'check'
                }],
                //[{ 'script': 'sub'}, { 'script': 'super' }],
                [{
                    'indent': '-1'
                }, {
                    'indent': '+1'
                }],
                [{
                    'color': []
                }, {
                    'background': []
                }],
                ['link', 'image', 'video', 'formula'],
                //[{ 'direction': 'rtl' }],
                ['clean'],
            ],
            viewAllUrl: ''
        }
    },
    methods: {
        update(table, status, id) {
            var param = {
                id: id,
                status: status,
                table: table,
                type: 'commonStatus'
            }
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'api.php',
                data: param
            }).then(function (response) {
                var data = response.data;
                console.log('status', data)
            })
        },
        addInit() {
            // this.getUnderof();
            // this.reset()
        },
        editInit() {
            // this.getDetail();
            // this.getUnderof();
        },
        viewInit() {
            // this.viewAllUrl = this.URL_ROOT + 'admin/' + this.page + '/all'
            // this.allDatas(true)
            this.getDetail()
        },
        reset() {
            this.form = {
                id: null,
                slider_image: '',
                status: true,
                heading: '',
                heading2: '',
                link: '',
                type: 'updateUser'

            };
        },
        getUnderof() {
            var pList = [];
            pList.push({
                label: 'Primary Menu',
                code: 0
            })
            $.ajax({
                "method": 'GET',
                "url": this.URL_ROOT + 'admin/' + this.page + '/allpage/?field=heading,id,underof',
                "success": (response) => {
                    if (response.status == "success") {
                        console.log(response.data);
                        $.each(response.data, function (key, param) {
                            //console.log(param,key);
                            pList.push({
                                label: param.heading,
                                code: param.id
                            })
                        })
                    }
                    this.pageList = pList;
                }
            })
            /**
             if(this.action=="add"){
                this.from.lorder = response.length+1;
            } */
        },
        getDetail() {
            var ev = this
            var param = {
                type: 'getAdminDetail'
            }
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'api.php',
                data: param
            }).then(function (response) {
                console.log(response.data)
                var data = response.data;
                ev.form = data.data
            })
        },
        allDatas() {
            var ev = this
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'api.php',
                data: {
                    type: 'updateUser',
                }
            }).then(function (response) {
                var data = response.data;
                ev.allData = data
            })
        },
        submit() {
            if (this.form.username === '') {
                this.$toasted.global.error({
                    message: 'Please enter Username'
                })
            } else if (this.form.email === '') {
                this.$toasted.global.error({
                    message: 'Please enter Email ID'
                })
            } else if (this.form.mobile === '') {
                this.$toasted.global.error({
                    message: 'Please enter Mobile Number'
                })
            } else if (this.form.add1 === '') {
                this.$toasted.global.error({
                    message: 'Please enter Your Address'
                })
            } else if (this.form.pass === '') {
                this.$toasted.global.error({
                    message: 'Please enter Your Password'
                })
            } else {
                var ev = this
                var status = ''
                if (ev.form.status == true) {
                    status = 1
                } else {
                    status = 0
                }
                this.file = this.$refs.avatar.files[0];
                let formData = new FormData();
                if (this.action == 'edit') {
                    this.form.type = 'updateUser';
                    formData.append('id', this.id);

                }
                formData.append('username', ev.form.username);
                formData.append('email', ev.form.email);
                formData.append('mobile', ev.form.mobile);
                formData.append('pass', ev.form.pass);
                formData.append('avatar', ev.file);
                formData.append('add1', ev.form.add1);
                formData.append('type', ev.form.type);
                formData.append('status', status);
                axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'api.php',
                    data: formData
                }).then(function (response) {
                    var data = response.data;
                    console.log(response)
                    if (data.status == "success") {
                        ev.$swal({
                            toast: true,
                            position: 'top-end',
                            timer: 5000,
                            icon: 'success',
                            timerProgressBar: true,
                            title: 'Action perform successfully'
                        })
                        //  window.location.href = 'index/'+ev.page;
                        ev.$router.push('/')
                    } else {
                        setTimeout(() => ev.$swal(data.msg), 1000);

                    }

                })
            }
        },
        remove(id) {
            var self = this;
            var param = {
                id: id,
                table: 'mss_slider',
                type: 'commonDelete'
            }
            this.$swal({
                title: "Delete this ?",
                text: "Are you sure? You won't be able to revert this!",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: "#f00",
                confirmButtonText: "Yes, Delete it!",
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {
                    axios({
                        method: 'POST',
                        url: this.$root.URL_ROOT + 'api.php',
                        data: param
                    }).then(function (response) {
                        var data = response.data;
                        self.allDatas()
                        console.log('commonDelete', data)
                    })
                }
            })
        },

    },
    mounted() {
        if (this.action == "view") {
            this.viewInit()
        } else if (this.action == "edit" && this.id > 0) {
            this.editInit()
        } else if (this.action == "add") {
            this.addInit();
        }
    },
    watch: {
        'action': function (val) {
            if (val == "view") {
                this.viewInit()
            } else if (val == "edit" && this.id > 0) {
                this.editInit()
            } else if (val == "add") {
                this.addInit();
            }
        },
        // 'form.linkname': function() {
        //     //var text = val.replace(' ', "+")
        //     //this.form.linkname = this.limitedword(text.replace(/\W/g, "+"),20);
        // },'form.pbody': function(val) {
        //     if(this.defaultSEO){
        //         this.form.meta_description = this.limitedword(this.striphtml(val),150);
        //     }
        // },
        // 'form.heading': function(val) {
        //     if(this.defaultSEO){
        //         this.form.meta_title = this.limitedword(val,20);
        //     }
        // },
        // 'loading': function(val) {
        //     if(val){
        //         this.$swal.showLoading();
        //     }else{
        //         this.$swal.close()
        //     }
        // },
        // 'q': function(newVal,oldVal) {
        //     if(newVal==''){
        //         this.viewAllUrl = this.URL_ROOT+'admin/'+this.page+'/all';
        //     }else if(newVal!=oldVal){
        //         this.viewAllUrl = this.URL_ROOT+'admin/'+this.page+'/all/'+newVal;
        //     }
        //     this.allDatas(false);
        // }
    }
}
</script>

<style scoped>
@import "~vue2-editor/dist/vue2-editor.css";
</style>
